import throttle from 'lodash/throttle';

const flyoutTriggerLinks = document.querySelectorAll(
	'.block-navigation-detailed-link[data-has-flyout="true"] > .wp-block-button .wp-block-button__link'
);

if (flyoutTriggerLinks.length) {
	flyoutTriggerLinks.forEach((link) => {
		link.addEventListener('mouseenter', (e) => {
			e.preventDefault();

			const activeFlyoutMenu = document.querySelector(
				'.block-navigation-detailed-link-flyout.active'
			);

			if (activeFlyoutMenu) {
				activeFlyoutMenu.classList.remove('active');
				activeFlyoutMenu
					.closest('.block-navigation-detailed-link')
					?.querySelector('.wp-block-button__link')
					?.classList.remove('active');
			}

			link.classList.add('active');

			setFlyoutMenuHeight(link);
		});
	});
}

const setFlyoutMenuHeight = (link) => {
	const blockNavigationColumnContent = link.closest(
		'.block-navigation-columns__content'
	);
	const flyoutMenu = link
		.closest('.block-navigation-detailed-link')
		?.querySelector('.block-navigation-detailed-link-flyout');

	if (!blockNavigationColumnContent || !flyoutMenu) {
		return;
	}

	flyoutMenu?.classList.add('active');
	blockNavigationColumnContent?.style.setProperty(
		'min-height',
		`${flyoutMenu.offsetHeight}px`
	);
};

const setFlyoutMenuWidth = () => {
	const activeLink = document.querySelector('.block-navigation-link.active');
	const activeSubmenu = activeLink?.querySelector(
		'.block-navigation-submenu'
	);
	const flyoutMenuColumn = activeSubmenu?.querySelector(
		'.block-navigation-link-column[data-has-flyout]'
	);
	flyoutMenuColumn?.style.setProperty(
		'--flyoutColumnWidth',
		flyoutMenuColumn.offsetWidth + 'px'
	);
};

const closeActiveFlyoutMenu = () => {
	const activeFlyoutMenu = document.querySelector(
		'.block-navigation-detailed-link-flyout.active'
	);
	const activeFlyoutLink = document.querySelector(
		'.block-navigation-detailed-link[data-has-flyout=true] > .wp-block-button .wp-block-button__link.active'
	);
	const blockNavigationColumns = document.querySelectorAll(
		'.block-navigation-columns__content'
	);

	activeFlyoutMenu?.classList.remove('active');
	activeFlyoutLink?.classList.remove('active');

	blockNavigationColumns?.forEach((column) => {
		column.style.removeProperty('min-height');
	});
};

window.addEventListener('resize', throttle(setFlyoutMenuWidth, 100));
window.addEventListener('navigation-submenu-opened', setFlyoutMenuWidth);
window.addEventListener('navigation-closed', closeActiveFlyoutMenu);
